<template>
	<DialogPanel class="transcription-panel"
		:scroll-body="true"
		@close="$emit( `close` )"
	>
		<template #title-text>{{ translate( "title" ) }}</template>
		<template #body>
			<div class="sub-body">
				<LoadingPlaceholder2 v-if="showPlaceholder" />
				<div v-else class="speech-blocks">
					<div
						v-for="( block, index ) in speechBlocks"
						:key="`block-${ index }`"
						class="speech-block"
					>
						<label v-if="block.anonymous" class="speaker" v-html="`${ translate( 'speakerLabel') } ${ block.speaker }`"></label>
						<label v-else class="speaker" v-html="formatText( block.speaker )"></label>
						<p class="text" v-html="formatText( block.text )"></p>
					</div>
				</div>
			</div>
		</template>
	</DialogPanel>
</template>

<script>
import { markdown } from "@teaming/common-util";
import DOMPurify from "dompurify";

import {
	DialogPanel,
	TranslateMixin,
	LoadingPlaceholder2
} from "@teaming/common-ui";

export default {
	name: "TranscriptionPanel",
	teamingPackage: "common-team",
	mixins: [ TranslateMixin, ],
	components: {
		DialogPanel,
		LoadingPlaceholder2,
	},
	props: {
		speechBlocks: {
			type: Array,
			required: true,
		},
	},
	computed: {
		showPlaceholder() {
			const { speechBlocks, } = this;
			return speechBlocks.length === 0;
		},
	},
	methods: {
		formatText( text ) {
			const renderedText = markdown.parse( text || "" );
			return DOMPurify.sanitize( renderedText );
		},
	},
};
</script>

<style lang="scss" scoped>
.transcription-panel .speech-blocks {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 2rem;
	margin: 1rem 0;
}

.transcription-panel .speech-block {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 0.5rem;
}

.transcription-panel .speaker {
	font-weight: 600;
}

// use a sub-body to show scrollbar
.transcription-panel .sub-body {
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	width: 100%;

	padding: 0 1rem;
	overflow-y: scroll;
}
</style>

<style lang="scss">
.transcription-panel .body {
	padding: 1rem;
}
</style>
